export default {
    methods: {
        /**
         * Get CSRF-Token
         */
        csrfToken() {
            return document.head.querySelector('meta[name="csrf-token"]').content
        },

        /**
         * Get CSRF-Token input field
         */
        csrfField() {
            return '<input type="hidden" name="_token" value="' + this.csrfToken() + '" />'
        },

        formatNegativePrice(price) {
            if (price < 0) {
                return 0
            }

            return price
        }
    }
}
